// src/app/services/crypto.service.ts
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import {environment} from "../../../environments/environment";
const C_KEY = `${environment.CK}`;

@Injectable({
  providedIn: 'root'
})
export class CryptoService {
  private readonly key = CryptoJS.enc.Utf8.parse( `${C_KEY}`); // 32 caracteres

  encrypt(data: string): string {
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(data, this.key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    const ivBase64 = CryptoJS.enc.Base64.stringify(iv);
    const encryptedBase64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);

    return `${ivBase64}:${encryptedBase64}`;
  }

  decrypt(encryptedData: string): string {
    const [ivBase64, encryptedBase64] = encryptedData.split(':');
    const iv = CryptoJS.enc.Base64.parse(ivBase64);
    const encryptedWords = CryptoJS.enc.Base64.parse(encryptedBase64);

    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encryptedWords } as any,
        this.key,
        { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
